/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import TimeAgo from 'react-timeago';
import get from 'lodash/get';
import CheckBox from 'Common/Components/Checkbox/styled';
import Button from 'shared/ui/Button';
import { WrapperColumn, RunIcon } from './Columns/styled';
import NameColumn from './Columns/NameColumn';
import { CheckHeader } from './Columns/CheckHeader';
import { CheckColumn } from './Columns/CheckColumn';

/**
 * Schedulers table (scheduled agents and scheduled cloud agents).
 * ctx: `{ fields, onChangeStatus(id, status, workspaces, type), isFetching, run(e, id, workspaces, isOnline, type, active) }`
 */
const scheduledAgentsSchema = {
  id: 'scheduledAgents',
  loading: { skeleton: ({ isFetching }) => isFetching },
  columns: [{
    header: () => <CheckHeader />,
    accessor: 'selected',
    id: 'Selected',
    maxWidth: 38,
    minWidth: 38,
    resizable: false,
    sortable: false,
    visible: true,
    cell: (rowInfo) => <CheckColumn rowInfo={ rowInfo } />,
    order: -1
  }, {
    header: () => <FormattedMessage id="schedule.table.columns.id" />,
    id: 'id',
    accessor: 'id',
    resizable: false,
    visible: false,
    cell: (rowInfo) => <WrapperColumn>{ rowInfo.original.value.id }</WrapperColumn>,
    order: ({ fields }) => get(fields, 'id.order', 1)
  }, {
    header: () => <FormattedMessage id="schedule.table.columns.name" />,
    id: 'description',
    accessor: 'description',
    resizable: false,
    cell: (rowInfo) => <NameColumn rowInfo={ rowInfo } />,
    order: ({ fields }) => get(fields, 'description.order', 2),
    maxWidth: 350,
    minWidth: 250
  }, {
    header: () => <FormattedMessage id="schedule.table.columns.nextRun" />,
    id: 'next_run',
    accessor: 'next_run',
    resizable: false,
    sortable: false,
    cell: (rowInfo) => (rowInfo.original.value.next_run ? <WrapperColumn><TimeAgo date={ rowInfo.original.value.next_run } /></WrapperColumn> : null),
    order: ({ fields }) => get(fields, 'nextRun.order', 3),
    maxWidth: 150,
    minWidth: 150
  }, {
    header: () => <FormattedMessage id="schedule.table.columns.crontab" />,
    id: 'crontab',
    resizable: false,
    cell: (rowInfo) => <WrapperColumn>{ rowInfo.original.value.crontab }</WrapperColumn>,
    order: ({ fields }) => get(fields, 'crontab.order', 4)
  }, {
    header: () => <FormattedMessage id="schedule.table.columns.runnerName" />,
    id: 'agent_name',
    sortable: false,
    resizable: false,
    cell: (rowInfo) => <WrapperColumn>{ rowInfo.original.value.type === 'cloud_agent' ? rowInfo.original.value.cloud_agent.name : rowInfo.original.value.agent.name }</WrapperColumn>,
    order: ({ fields }) => get(fields, 'agentName.order', 5)
  }, {
    header: () => <FormattedMessage id="schedule.table.columns.tool" />,
    id: 'executor_name',
    resizable: false,
    sortable: false,
    cell: (rowInfo) => {
      const executors = get(rowInfo, 'original.value.agent.executors', []);
      const executorsNames = executors.map((executor) => executor.name).join(', ');
      return <WrapperColumn>{ executorsNames }</WrapperColumn>;
    },
    order: ({ fields }) => get(fields, 'tool.order', 6)
  }, {
    header: () => <FormattedMessage id="schedule.table.columns.run" />,
    id: 'run',
    resizable: false,
    sortable: false,
    cell: (rowInfo, { run }) => <WrapperColumn><Button variant="ghost" id="scheduler-table-trigger" onClick={ (e) => run(e, rowInfo.original.id, rowInfo.original.value.workspaces, rowInfo.original.value.type === 'agent' && rowInfo.original.value.agent.is_online, rowInfo.original.value.type, rowInfo.original.value.active) } title="Trigger" ariaLabel="Trigger" startIcon={ <RunIcon /> } /></WrapperColumn>,
    order: ({ fields }) => get(fields, 'run.order', 7)
  }, {
    header: () => <FormattedMessage id="schedule.table.columns.active" />,
    id: 'active',
    resizable: false,
    cell: (rowInfo, { onChangeStatus }) => <WrapperColumn><CheckBox checked={ rowInfo.original.value.active } onClick={ () => onChangeStatus(rowInfo.original.id, !rowInfo.original.value.active, rowInfo.original.value.workspaces, rowInfo.original.value.type) } /></WrapperColumn>,
    order: ({ fields }) => get(fields, 'active.order', 8)
  }]
};

export default scheduledAgentsSchema;
